import { Box, List, Link } from "@mui/material";

import useSidebarHelper from "./helper";
import SideBarComp from "./sidebar-comp";
import { RootState } from "../../redux/store";
import "../../components/sidebar/sidebar.scss";
import { IMAGES, Paths } from "../../common/constants";
import { useAppSelector } from "../../hooks/useAppSelector";

const SideBar = () => {
  const {
    version,
    userType,
    location,
    cmsLinks,
    sidebarItems,

    hasPermission,
  } = useSidebarHelper();

  const sidebarCollapsed = useAppSelector(
    (state: RootState) => state.globalcontent.sidebarCollapsed,
  );

  return (
    <Box
      className={`sidebar-outer-wrapper ${sidebarCollapsed ? "collapsed" : ""}`}
    >
      {/* Inner scrollable container */}
      <Box className="sidebar-container">
        <List
          className={`sidebarWrapper ${sidebarCollapsed ? "collapsed" : ""}`}
        >
          {hasPermission("analytics") && (
            <SideBarComp
              src={IMAGES.Analytics}
              alt="Analytics_Icon"
              heading="Analytics"
              link={Paths.ANALYTICS}
              active={location.pathname.includes(Paths.ANALYTICS)}
            />
          )}

          {["batches", "strains"].some(hasPermission) && (
            <>
              {["analytics"].some(hasPermission) && (
                <div className="divider"></div>
              )}
              <h4 className="sidebarTitle">INVENTORY</h4>
              {sidebarItems
                .filter((item) => ["batches", "strains"].includes(item.key))
                .map(
                  (item) =>
                    hasPermission(item.key) && (
                      <SideBarComp
                        key={item.key}
                        src={item.image}
                        alt={`${item.heading}_Icon`}
                        heading={item.heading}
                        link={item.link}
                        active={location.pathname.includes(item.link)}
                      />
                    ),
                )}
            </>
          )}

          {["rewards_management", "qr_code"].some(hasPermission) && (
            <>
              {["analytics", "batches", "strains"].some(hasPermission) && (
                <div className="divider"></div>
              )}

              <h4 className="sidebarTitle">Management</h4>

              {(userType === "MANUFACTURER_USER" ||
                hasPermission("employees_management")) && (
                <>
                  <SideBarComp
                    src={IMAGES.Employee}
                    alt="Employees_Icon"
                    heading="Employees Management"
                    link={Paths.EMPLOYEEES_MANAGEMENT}
                    active={location.pathname.includes(
                      Paths.EMPLOYEEES_MANAGEMENT,
                    )}
                  />
                </>
              )}

              {(userType === "MANUFACTURER_USER" ||
                userType === "MANUFACTURER_EMPLOYEE") && (
                <>
                  <SideBarComp
                    src={IMAGES.MenuUser}
                    alt="Consumer_Icon"
                    heading="Consumers Management"
                    link={Paths.CONSUMERS_MANAGEMENT}
                    active={location.pathname.includes(
                      Paths.CONSUMERS_MANAGEMENT,
                    )}
                  />
                </>
              )}

              {sidebarItems
                .filter((item) => ["rewards_management"].includes(item.key))
                .map(
                  (item) =>
                    hasPermission(item.key) && (
                      <SideBarComp
                        key={item.key}
                        src={item.image}
                        alt={`${item.heading}_Icon`}
                        heading={item.heading}
                        link={item.link}
                        active={location.pathname.includes(item.link)}
                        comingSoon={item.key === "rewards_management"}
                      />
                    ),
                )}

              {(userType === "MANUFACTURER_USER" ||
                hasPermission("api_connection")) && (
                <>
                  <SideBarComp
                    src={IMAGES.Api}
                    alt="api_icon"
                    heading="API Connection"
                    link={Paths.API_CONNECTIONS}
                    active={location.pathname.includes(Paths.API_CONNECTIONS)}
                  />
                </>
              )}

              {sidebarItems
                .filter((item) => ["qr_code"].includes(item.key))
                .map(
                  (item) =>
                    hasPermission(item.key) && (
                      <SideBarComp
                        key={item.key}
                        src={item.image}
                        alt={`${item.heading}_Icon`}
                        heading={item.heading}
                        link={item.link}
                        active={location.pathname.includes(item.link)}
                      />
                    ),
                )}
            </>
          )}

          {["announcements"].some(hasPermission) && (
            <>
              {["analytics", "qr_code", "batches", "strains"].some(
                hasPermission,
              ) && <div className="divider"></div>}
              <h4 className="sidebarTitle">Other</h4>
              {sidebarItems
                .filter((item) => ["announcements"].includes(item.key))
                .map(
                  (item) =>
                    hasPermission(item.key) && (
                      <SideBarComp
                        key={item.key}
                        src={item.image}
                        alt={`${item.heading}_Icon`}
                        heading={item.heading}
                        link={item.link}
                        active={location.pathname.includes(item.link)}
                      />
                    ),
                )}
            </>
          )}

          {sidebarItems
            .filter((item) => ["support"].includes(item.key))
            .map((item) => (
              <SideBarComp
                key={item.key}
                src={item.image}
                alt={`${item.heading}_Icon`}
                heading={item.heading}
                link={item.link}
                active={location.pathname.includes(item.link)}
              />
            ))}

          <div className="sidebarFooter">
            <div className="footerLinks">
              <Link
                href={
                  cmsLinks?.privacy_policy && cmsLinks?.privacy_policy?.trim()
                    ? cmsLinks.privacy_policy
                    : window.location.href
                }
                target="_blank"
                rel="noopener noreferrer"
                className="footerLink"
              >
                Privacy Policy
              </Link>
              <Link
                href={
                  cmsLinks?.terms_of_use && cmsLinks?.terms_of_use?.trim()
                    ? cmsLinks.terms_of_use
                    : window.location.href
                }
                target="_blank"
                rel="noopener noreferrer"
                className="footerLink"
              >
                Terms of Use
              </Link>
            </div>

            <div className="footerLinks privacyChoice">
              <Link
                href={
                  cmsLinks?.your_privacy_choices &&
                  cmsLinks?.your_privacy_choices?.trim()
                    ? cmsLinks.your_privacy_choices
                    : window.location.href
                }
                target="_blank"
                rel="noopener noreferrer"
                className="footerLink"
              >
                <img
                  src={IMAGES.PrivacyChoiceIcon}
                  alt="Privacy Choice Icon"
                  className="privacyChoiceIcon"
                />
                Your Privacy Choices
              </Link>
            </div>

            {version ? (
              <p className="versionText">
                {version.toLowerCase().startsWith("v")
                  ? version
                  : `v ${version}`}
              </p>
            ) : null}
          </div>
        </List>
      </Box>
    </Box>
  );
};

export default SideBar;
